import { Box, Button, Circle, Progress, Text } from "@chakra-ui/react";
import { ReactComponent as PlayButton } from '../../svg/play-button.svg'
import { RepeatIcon } from '@chakra-ui/icons'
import { useState } from "react";
import Scorecard from "./Scorecard";
import { useDispatch, useSelector } from "react-redux";
import Confetti from 'react-dom-confetti';
import { useEffect } from "react";
import { quizPlayAgain, resetQuizState, setAutocompleteVisibility } from "../../redux/actions/action";
import { ReactComponent as LowScore } from '../../svg/low-score.svg'
import { getScoreAndScorecard } from "../../redux/api/apiCalls";
import { useHistory } from "react-router";

export default function QuizCompletion({ interval, course_id }) {
    const [scorecardOpen, setScorecardOpen] = useState(false)
    const questions = useSelector(state => state.quizQuestionsState.questions)
    // const { selectedCourse } = useSelector(state => state.selectedCourse)

    const [confettiActive, setConfettiActive] = useState(false)
    const [scores, setScores] = useState([])
    const [scoreIsLoading, setScoreIsLoading] = useState(false)
    const [scoreLoadingError, setScoreLoadingError] = useState(null)
    const [result, setResult] = useState(null)
    const dispatch = useDispatch()
    const history = useHistory()

    console.log(questions)
    console.log(history.location.state.attemptsLeft)

    const onScorecardClose = () => setScorecardOpen(false)

    const scorecardHandler = () => {
        setScorecardOpen(true)
    }

    const getScores = async () => {
        setScoreIsLoading(true)
        try {
            let response = await getScoreAndScorecard(questions.id)
            setScores(response)
            setScoreIsLoading(false)
        }
        catch (error) {
            console.log(error.message)
            setScoreLoadingError(error.message)
            setScoreIsLoading(false)
        }
    }

    const evaluateResult = () => {
        if (Number(scores[0]) < 75) {
            setResult('Fail')
        }
        else {
            setResult('Pass')
        }
    }

    useEffect(() => {
        console.log("useEffect")
        if (!scoreIsLoading && scores.length === 2) {
            evaluateResult()
        }
        // eslint-disable-next-line
    }, [scoreIsLoading])

    useEffect(() => {
        getScores()
        return () => dispatch(resetQuizState())
        // eslint-disable-next-line
    }, [])

    const config = {
        angle: 90,
        spread: 360,
        startVelocity: 40,
        elementCount: 300,
        dragFriction: 0.12,
        duration: 5000,
        stagger: 5,
        width: "10px",
        height: "10px",
        perspective: "500px",
        colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"]
    };

    useEffect(() => {
        clearInterval(interval)
        setConfettiActive(true)
        // eslint-disable-next-line
    }, [])

    const playAgainHandler = () => {
        dispatch(resetQuizState())
        dispatch(quizPlayAgain())
        history.push({
            state: { attemptsLeft: questions.topic_id ? history.location.state.attemptsLeft : history.location.state.attemptsLeft - 1 }
        })
    }

    return (
        <Box
            w={['95%', '95%', '95%', '90%', '70%']}
            // maxWidth = '100%'
            d='flex'
            flexDir='column'
            justifyContent='flex-start'
            alignItems='center'
            minH='90vh'
            pt='6rem'
            overflow='hidden'
            onClick={(e) => {
                e.stopPropagation()
                dispatch(setAutocompleteVisibility(false))
            }}
        >
            {scoreIsLoading &&
                <>
                    <Text
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontSize={['32px', '32px', '32px', '48px']}
                        fontWeight='800'
                        color='#000000'
                        mb='1rem'
                    >
                        Calculating...
                    </Text>
                    <Progress size='xs' isIndeterminate width='90%' mb='1rem' />
                </>
            }
            {
                result === 'Pass' &&
                <>
                    <Text
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontSize={['32px', '32px', '32px', '48px']}
                        fontWeight='800'
                        color='#000000'
                        mb='2rem'
                    >
                        Congratulations!
                    </Text>
                    <Box
                        position='relative'
                        width={['85%', '85%', '50%', '45%', '40%']}
                        d='flex'
                        justifyContent='center'
                        alignItems='center'
                        flexDir='column'
                    >
                        <Circle
                            size='160px'
                            bg='linear-gradient(180deg, rgba(255, 168, 0, 0.78) 0%, rgba(253, 184, 12, 0.850402) 32%, #FADA27 100%)'
                            boxShadow='0px 6px 24px rgba(0, 0, 0, 0.15'
                            border='3px solid rgba(255, 255, 255, 0.5'
                        >
                            <Circle
                                size='140px'
                                boxShadow='drop-shadow(0px 6px 24px rgba(0, 0, 0, 0.15)'
                                border='3px solid'
                                style={{ borderImageSource: 'linear-gradient(133.49deg, rgba(255, 251, 230, 0.23) 15.52%, rgba(255, 255, 255, 0) 36.42%)' }}
                            >
                                <Circle
                                    size='110px'
                                    bg='linear-gradient(180deg, rgba(251, 182, 48, 0.57) 0%, rgba(250, 218, 39, 0.9) 60.94%)'
                                    boxShadow='0px 6px 24px rgba(0, 0, 0, 0.15'
                                    border='3px solid #FFFFFF'
                                >
                                    <Circle
                                        size='100px'
                                        bg='linear-gradient(180deg, rgba(251, 182, 48, 0.57) 0%, rgba(250, 218, 39, 0.9) 60.94%)'
                                        boxShadow='0px 6px 24px rgba(0, 0, 0, 0.15'
                                        border='rgba(254, 250, 229, 0.2)'
                                    >
                                        <Text
                                            style={{ fontFamily: 'Mulish, sans-serif' }}
                                            fontSize='14px'
                                            fontWeight='800'
                                            color='#FFFFFF'
                                        >
                                            <span style={{ fontSize: '30px' }}>{scores[0]}</span>/100
                                            <Confetti active={confettiActive} config={config} />
                                        </Text>
                                    </Circle>
                                </Circle>
                            </Circle>
                        </Circle>
                        <Box
                            w={['90%', '80%']}
                            d='flex'
                            justifyContent='space-between'
                            alignItems='center'
                            h='40px'
                            position='relative'
                            mt='-1.5rem'
                            mb='2rem'
                        >
                            <Box
                                w='25%'
                                h='100%'
                                bg='#d34343'
                                position='relative'
                            >
                                <PlayButton height='100%' fill='white' style={{ position: 'absolute', left: '-5' }} />
                            </Box>
                            <Box
                                w='25%'
                                h='100%'
                                bg='#d34343'
                                position='relative'
                            >
                                <PlayButton height='100%' fill='white' style={{ position: 'absolute', right: '-5', transform: 'rotate(180deg)' }} />
                            </Box>
                            <Box
                                bg='linear-gradient(90.2deg, #F27B7B 1%, #CB3535 100.48%)'
                                borderRadius='12px'
                                boxShadow='0px 4px 4px rgba(0, 0, 0, 0.15)'
                                width='60%'
                                height='40px'
                                d='flex'
                                position='absolute'
                                left='20%'
                                top='-2'
                                justifyContent='center'
                                alignItems='center'
                            >
                                <Text
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    fontSize={['20px', '20px', '22px', '24px']}
                                    fontWeight='800'
                                    color='#FFFFFF'
                                >
                                    Your Score
                                </Text>
                            </Box>
                        </Box>
                    </Box>
                </>
            }

            {
                result === 'Fail' &&
                <>
                    <Box
                        position='relative'
                        width={['85%', '85%', '50%', '45%', '45%']}
                        d='flex'
                        justifyContent='center'
                        alignItems='center'
                        flexDir='column'
                    >
                        <LowScore />
                        <Text
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            fontSize={['32px', '32px', '32px', '48px']}
                            fontWeight='800'
                            color='#000000'
                            mb='2rem'
                        >
                            Low Score!
                        </Text>
                        <Text
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            fontSize={['16px', '16px', '16px', '24px']}
                            fontWeight='700'
                            color='#000000'
                            mb='2rem'
                        >
                            <span style={{ color: '#e16663' }}>{scores[0]}</span>/100
                        </Text>
                        <Text
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            fontSize={['16px', '16px', '16px', '24px']}
                            fontWeight='700'
                            color='#000000'
                            mb='2rem'
                        >
                            Don’t Worry! You still have more attempts
                        </Text>
                    </Box>
                </>
            }

            {
                result &&
                <Box
                    w={['90%', '90%', '70%', '55%', '55%']}
                    d='flex'
                    justifyContent='space-between'
                    alignItems='center'
                >

                    <Button
                        bg='linear-gradient(273.03deg, #F24197 0.67%, rgba(242, 65, 151, 0.63) 100%)'
                        borderRadius='7px'
                        p={['20px 18px', '20px 30px', '20px 35px']}
                        boxShadow='0px 4px 8px rgba(0, 0, 0, 0.1)'
                        d='flex'
                        justifyContent='center'
                        alignItems='center'
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif', gap: '0.5rem' }}
                        _hover={{ bg: 'linear-gradient(273.03deg, #d93a86 0.67%, rgba(217, 58, 134, 0.63) 100%)' }}
                        fontSize={['12px', '15px']}
                        fontWeight='800'
                        color='#FFFFFF'
                        onClick={scorecardHandler}
                    >
                        Scorecard
                    </Button>

                    <Button
                        bg='linear-gradient(90.57deg, #7B90F7 3.35%, #3E59DE 94.78%)'
                        borderRadius='7px'
                        p={['20px 18px', '20px 30px', '20px 35px']}
                        boxShadow='0px 4px 8px rgba(0, 0, 0, 0.1)'
                        d='flex'
                        justifyContent='center'
                        alignItems='center'
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif', gap: '0.5rem' }}
                        _hover={{ bg: 'linear-gradient(90.57deg, #6e81dd 3.35%, #3750c6 94.78%)' }}
                        fontSize={['12px', '15px']}
                        fontWeight='800'
                        color='#FFFFFF'
                        disabled={!history.location.state.attemptsLeft || (!questions.topic_id && history.location.state.attemptsLeft === 1)}
                        onClick={playAgainHandler}
                    >
                        Play Again <RepeatIcon fill='white' width='18px' height='18px' />
                    </Button>

                    <Button
                        bg='linear-gradient(90.57deg, #6a7cd8 3.35%, #3146aa 94.78%)'
                        borderRadius='7px'
                        p={['20px 18px', '20px 30px', '20px 35px']}
                        boxShadow='0px 4px 8px rgba(0, 0, 0, 0.1)'
                        d='flex'
                        justifyContent='center'
                        alignItems='center'
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif', gap: '0.5rem' }}
                        _hover={{ bg: 'linear-gradient(90.57deg, #4c5a9e 3.35%, #253586 94.78%)' }}
                        fontSize={['12px', '15px']}
                        fontWeight='800'
                        color='#FFFFFF'
                        onClick={() => history.push('/courses/' + course_id)}
                    >
                        Next
                    </Button>
                </Box>
            }
            {
                result && scores.length === 2 &&
                <Scorecard isOpen={scorecardOpen} onClose={onScorecardClose} questions={questions.question || []} scoreDetails={scores || []} />
            }

            {scoreLoadingError && <Text fontSize='14px' color='red.500' style={{ fontFamily: 'Mulish, sans-serif' }} >{scoreLoadingError}</Text>}
        </Box>
    )
}